import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Authorization } from "../../../Context/Authorization";
import Table from "react-bootstrap/Table";
import Preloader from "../../../shared/PreLoaders";

const DivisionLoanRecovery = () => {
  const { divisionId } = useParams();
  const [vfcList, setVfcList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // 'all' or 'range'
  const [expandedRanges, setExpandedRanges] = useState([]);
  const [selectedRangeId, setselectedRangeId] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [summary, setSummary] = useState({});
  const Api = process.env.REACT_APP_API;

  const LOCAL_KEY = `divisionLoanDataCache_${divisionId}`;

  const saveToLocalCache = (vfcList, summary) => {
    localStorage.setItem(
      LOCAL_KEY,
      JSON.stringify({ vfcList, summary, timestamp: new Date().toISOString() })
    );
  };

  const loadFromLocalCache = () => {
    const cached = localStorage.getItem(LOCAL_KEY);
    return cached ? JSON.parse(cached) : null;
  };

  const fetchVfcData = async () => {
    const config = Authorization();
    try {
      const res = await axios.get(
        `${Api}/api/drill/loan/by-division/${divisionId}`,
        config
      );
      setVfcList(res.data.data);
      saveToLocalCache(res.data.data, res.data.summary);
      setSummary(res.data.summary);
    } catch (error) {
      console.error("Failed to load VFCs", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const cached = loadFromLocalCache();
    if (cached && cached.vfcList) {
      setVfcList(cached.vfcList);
      setSummary(cached.summary || {}); // defensive
      setLoading(false);
    } else {
      fetchVfcData();
    }
  }, [divisionId]);

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  const formatAmount = (amount) => {
    if (amount >= 10000000) {
      return (amount / 10000000).toFixed(2) + " Cr"; // Crores
    } else if (amount >= 100000) {
      return (amount / 100000).toFixed(2) + " L"; // Lakhs
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(2) + " K"; // Thousands
    }
    return amount; // Return as is if less than 1000
  };
  const toggleRangeExpand = (rangeId) => {
    setExpandedRanges((prev) =>
      prev.includes(rangeId)
        ? prev.filter((id) => id !== rangeId)
        : [...prev, rangeId]
    );
  };

  if (loading) return <Preloader loading={true} />;
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              ← Back
            </li>
            <li
              className="breadcrumb-item active"
              style={{
                color: "red",
                cursor: "pointer",
              }}
              onClick={() => navigate("/dashboard")}
            >
              🏠 Home
            </li>
            <li
              className="breadcrumb-item"
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => navigate(+1)}
            >
              → Previous
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          onClick={() => {
            localStorage.removeItem(LOCAL_KEY);
            setLoading(true);
            fetchVfcData();
          }}
        >
          🔄 Refresh Now
        </button>

        <div className="text-muted small">
          Last Refreshed:
          {loadFromLocalCache()?.timestamp
            ? formatDateTime(loadFromLocalCache().timestamp)
            : "Not Available"}
        </div>
      </div>
      <div className="card bg-gradient-CoolSky card-img-holder text-white">
        <div className="card-body">
          <img
            src={require("../../../../assets/images/dashboard/circle.png")}
            className="card-img-absolute"
            alt="circle"
          />

          <h4 className="font-weight-normal mb-3">
            {" "}
            {vfcList.length > 0 ? vfcList[0].divisionName : "Loading..."}{" "}
            Division - Deaprtment Loan
          </h4>

          <h3>
            Loan Amount Recovered -{" "}
            {formatAmount(summary?.totalDepartmentRecoveredAmount || 0)}
          </h3>
        </div>
      </div>
      <div className="mt-4">
        <button
          className={`btn btn-outline-cool-sky m-1 ${
            selectedOption === "all" ? "active" : ""
          }`}
          onClick={() => setSelectedOption("all")}
        >
          All Ranges
        </button>

        {selectedOption === "range" && (
          <div className="mt-3">
            {vfcList
              .sort((a, b) => a.rangeName.localeCompare(b.rangeName))
              .map((range) => (
                <button
                  key={range.rangeId}
                  className={`btn btn-outline-natural-green m-1 ${
                    selectedRangeId === range.rangeId ? "active" : ""
                  }`}
                  onClick={() => {
                    setselectedRangeId(range.rangeId);
                    if (selectedRangeId === "range") {
                      setExpandedRanges({ [range.rangeId]: true });
                    }
                  }}
                >
                  {range.rangeName}
                </button>
              ))}
          </div>
        )}

        {selectedOption === "all" && (
          <div className="mt-4">
            {[...vfcList]
              .sort((a, b) => a.rangeName.localeCompare(b.rangeName))
              .map((range) => (
                <div key={range.rangeId} className="mt-3">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      background: "white",
                      padding: "10px",
                      borderRadius: "5px",
                    }}
                    onClick={() => toggleRangeExpand(range.rangeId)}
                  >
                    <h5 className="mb-0"> {range.rangeName}</h5>
                    <span style={{ fontSize: "1.2rem" }}>
                      {expandedRanges.includes(range.rangeId) ? "−" : "+"}
                    </span>
                  </div>

                  {expandedRanges.includes(range.rangeId) && (
                    <>
                      <Table
                        striped
                        bordered
                        hover
                        className="mt-2 text-center"
                      >
                        <thead>
                          <tr>
                            <th rowSpan="2">#</th>
                            <th>Range Name</th>
                            <th>Male Beneficiaries</th>
                            <th>Female Beneficiaries</th>
                            <th>Third Gender Beneficiaries</th>
                            <th>Amount Disbursed</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[range].map((r, idx) => (
                            <tr key={r.rangeId}>
                              <td>{idx + 1}</td>
                              <td
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  navigate(`/drill/range-recovery/${r.rangeId}`)
                                }
                              >
                                {r.rangeName}
                              </td>

                              <>
                                <td>{r.departmentLoan.male}</td>
                                <td>{r.departmentLoan.female}</td>
                                <td>{r.departmentLoan.others}</td>
                                <td>
                                  {r.departmentLoanAmount.toLocaleString(
                                    "en-IN"
                                  )}
                                </td>
                              </>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  )}
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DivisionLoanRecovery;
